import { SettingsRoutes } from 'pages/settings/route/type'
import { DeveloperRoutes } from './type'

const root = `${SettingsRoutes.root}/${DeveloperRoutes.root}`
const accessTokens = `${root}/${DeveloperRoutes.accessTokens}`
const applications = `${root}/${DeveloperRoutes.applications}`
const authorizedApps = `${root}/${DeveloperRoutes.authorizedApps}`

export const DeveloperPath = {
  root: root,
  accessTokens: accessTokens,
  applications: applications,
  authorizedApps: authorizedApps,
}
